import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import { logError } from "./lib/log";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cristalda_cart") || "[]");
    } catch (err) {
      logError("cart-parse", err);
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("cristalda_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((item) => {
    setItems((prev) => [...prev, { ...item, _key: `${item.experience_id}-${item.date}-${item.time}-${Date.now()}` }]);
  }, []);
  const removeItem = useCallback((key) => setItems((prev) => prev.filter((i) => i._key !== key)), []);
  const clearCart = useCallback(() => setItems([]), []);

  const total = items.reduce((s, i) => s + i.subtotal, 0);

  const value = useMemo(
    () => ({ items, addItem, removeItem, clearCart, total, count: items.length }),
    [items, addItem, removeItem, clearCart, total],
  );

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
